"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Modal", {
  enumerable: true,
  get: function () {
    return _Modal2.default;
  }
});
Object.defineProperty(exports, "ModalContent", {
  enumerable: true,
  get: function () {
    return _ModalContent2.default;
  }
});
Object.defineProperty(exports, "ModalFooter", {
  enumerable: true,
  get: function () {
    return _ModalFooter2.default;
  }
});
var _Modal2 = _interopRequireDefault(require("./Modal"));
var _ModalContent2 = _interopRequireDefault(require("./ModalContent"));
var _ModalFooter2 = _interopRequireDefault(require("./ModalFooter"));